import roomToItemsMap from '@/mocks/roomToItemsMap.json';

interface RoomToItemMap {
  [key: string]: Array<number>;
}

export const ROOM_TO_ITEMS_MAP: RoomToItemMap = roomToItemsMap;
